import React, { useContext, useState } from 'react';
import { UserContext } from '../../UserContext';
import { Link } from 'react-router-dom';
import { Menu, MenuButton, MenuItems, MenuItem, Transition } from '@headlessui/react';
import { BellIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import AlertDismissible from '../../Layout/Alerts/AlertDismissible';

const baseURL = 'http://localhost:8000';

const TopMenu = () => {
    const { user, sucursal, pedidos } = useContext(UserContext);
    const [notificationCount] = useState(10); // Simulado - puedes conectar con datos reales

    const renderAlerts = (item) => {
        const currentPath = window.location.pathname;
        const url = `/admin/nuevo-pedido/${item.id}`;
        if (currentPath === url) return null;
        
        return (
            <AlertDismissible
                type="warning"
                message={`¡Atención! Tienes pedidos ${item.estatus}s.`}
                link={url}
                linkText="Ir al pedido"
                items={pedidos}
                multiple={true}
                key={item.id}
                dissmisable={false}
            />
        );
    };

    return (
        <div>
            {/* Header principal con gradiente cyan */}
            <div className="bg-[#11cdef] -mx-2.5 px-6 md:px-8 pt-8 pb-32 md:pb-36">
                {/* Contenedor del top bar */}
                <div className="border-b border-white/30 pb-2">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        {/* Logo y título del sistema */}
                        <div className="flex items-center h-10">
                            <h5 className="text-white font-medium text-lg md:text-xl m-0">
                                Sistema Dento Metric - {sucursal}
                            </h5>
                        </div>

                        {/* Perfil y notificaciones */}
                        <div className="flex items-center justify-end gap-3 md:gap-4">
                            {/* Perfil de usuario */}
                            <Link 
                                to="/admin/usuarios/perfil" 
                                className="flex items-center gap-3 group transition-all duration-300 hover:opacity-90 cursor-pointer"
                                title="Ver Perfil"
                            >
                                {/* Imagen de perfil */}
                                <div className="relative">
                                    <div className="h-10 w-10 md:h-11 md:w-11 rounded-full border-2 border-white shadow-md overflow-hidden bg-white">
                                        <img 
                                            src={user.image ? `${baseURL}${user.image}` : '/images/perfil2.png'} 
                                            alt={user.name || 'Perfil'} 
                                            className="h-full w-full object-cover"
                                        />
                                    </div>
                                </div>
                                
                                {/* Nombre de usuario */}
                                <p className="hidden md:block text-white text-xs font-bold uppercase m-0 transition-all duration-300 group-hover:text-gray-900 group-hover:drop-shadow-[2px_2px_4px_rgba(0,0,0,0.5)] truncate w-36 lg:w-48">
                                    {user.name}
                                </p>
                            </Link>

                            {/* Notificaciones con dropdown comentadas de momento */}
                            {/*
                            <Menu as="div" className="relative">
                                <MenuButton className="relative flex items-center justify-center text-white hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 rounded-full p-1">
                                    <BellIcon className="h-7 w-7 md:h-8 md:w-8" />
                                    
                                 
                                    {notificationCount > 0 && (
                                        <span className="absolute -top-1 -right-1 flex items-center justify-center h-5 w-5 rounded-full bg-white border-2 border-[#11cdef] shadow-md">
                                            <span className="text-[#0033ff] text-[9px] font-bold">
                                                {notificationCount > 99 ? '99+' : notificationCount}
                                            </span>
                                        </span>
                                    )}
                                </MenuButton>

                              
                                <Transition
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <MenuItems className="absolute right-0 mt-2 w-80 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                                        <div className="p-4">
                                            <h3 className="text-sm font-semibold text-gray-900 mb-3">
                                                Notificaciones ({notificationCount})
                                            </h3>
                                            
                                           
                                            <div className="space-y-2 max-h-96 overflow-y-auto">
                                                {notificationCount > 0 ? (
                                                    <>
                                                        <MenuItem>
                                                            {({ active }) => (
                                                                <div className={`p-3 rounded-md cursor-pointer transition-colors ${active ? 'bg-gray-100' : 'bg-white'}`}>
                                                                    <p className="text-sm text-gray-800 font-medium">Nueva cita agendada</p>
                                                                    <p className="text-xs text-gray-500 mt-1">Hace 5 minutos</p>
                                                                </div>
                                                            )}
                                                        </MenuItem>
                                                        <MenuItem>
                                                            {({ active }) => (
                                                                <div className={`p-3 rounded-md cursor-pointer transition-colors ${active ? 'bg-gray-100' : 'bg-white'}`}>
                                                                    <p className="text-sm text-gray-800 font-medium">Recordatorio de cita</p>
                                                                    <p className="text-xs text-gray-500 mt-1">Hace 1 hora</p>
                                                                </div>
                                                            )}
                                                        </MenuItem>
                                                    </>
                                                ) : (
                                                    <p className="text-sm text-gray-500 text-center py-4">
                                                        No hay notificaciones nuevas
                                                    </p>
                                                )}
                                            </div>

                                          
                                            {notificationCount > 0 && (
                                                <div className="mt-3 pt-3 border-t border-gray-200">
                                                    <button className="text-sm text-[#11cdef] hover:text-[#0033ff] font-medium w-full text-center transition-colors">
                                                        Ver todas las notificaciones
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </MenuItems>
                                </Transition>
                            </Menu>
                            */}
                        </div>
                    </div>
                </div>

                {/* Alertas de pedidos - comentado como en el original */}
                {/*pedidos.length > 0 &&
                    <AlertDismissible
                        type="warning"
                        message="¡Atención! Tienes pedidos incompletos."
                        link="/admin/nuevo-pedido"
                        linkText="Ir al pedido"
                        items={pedidos}
                        multiple={true}
                        dissmisable={false}
                        listIcon="add_shopping_cart"
                    />
                */}
            </div>
        </div>
    );
};

export default TopMenu;